
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

class Chart1 extends Component {
    constructor() {
        super();
        this.state = {
            data: null
        }
    }
    componentDidMount() {
        Alert.Loading(true)
        var where = {}
        if (this.props.selected_dealer) {
            where.dealer_code = [this.props.selected_dealer]
        }
        APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L, where, ({ datas }) => {
            this.setState({
                data: datas
            }, () => {
                Alert.LoadingClose()
                this.setChart(datas)
            })
        })
    }
    getValue = (raw_data, qtr_num, key_num) => {
        var res = 0
        if (raw_data[qtr_num] && raw_data[qtr_num][key_num]) {
            res = Math.round(raw_data[qtr_num][key_num])
        }
        return res
    }
    setChart(datas) {
        const colors = ['#00dd00', '#ffe555', '#dd0000'];
        var categories = [
            'Quarter 2/FY21<br/>(NPS:' + (this.getValue(datas, "qtr2", "c_per") - this.getValue(datas, "qtr2", "a_per")) + ')',
            'Quarter 3/FY21<br/>(NPS:' + (this.getValue(datas, "qtr3", "c_per") - this.getValue(datas, "qtr3", "a_per")) + ')',
            'Quarter 4/FY21<br/>(NPS:' + (this.getValue(datas, "qtr4", "c_per") - this.getValue(datas, "qtr4", "a_per")) + ')',
            'Quarter 1/FY21<br/>(NPS:' + (this.getValue(datas, "qtr1", "c_per") - this.getValue(datas, "qtr1", "a_per")) + ')'
        ]
        const series = [{
            name: '% Top 2 Box',
            data: [this.getValue(datas, "qtr2", "c_per"), this.getValue(datas, "qtr3", "c_per"), this.getValue(datas, "qtr4", "c_per"), this.getValue(datas, "qtr1", "c_per")]
        }, {
            name: '% Rating 7-8',
            data: [this.getValue(datas, "qtr2", "b_per"), this.getValue(datas, "qtr3", "b_per"), this.getValue(datas, "qtr4", "b_per"), this.getValue(datas, "qtr1", "b_per")]
        }, {
            name: '% Bottom 0-6',
            data: [this.getValue(datas, "qtr2", "a_per"), this.getValue(datas, "qtr3", "a_per"), this.getValue(datas, "qtr4", "a_per"), this.getValue(datas, "qtr1", "a_per")]
        }]
        Highcharts.chart('chart_3_1', {
            chart: {
                type: 'bar'
            },
            colors: colors,
            title: {
                text: 'NPS-OS (%)'
            },
            xAxis: {
                categories: categories
            },
            yAxis: {
                max: 100,
                min: 0,
                title: {
                    text: ''
                }
            },
            legend: {
                reversed: true
            },
            series: series,
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: (e) => this.handleClickChart(e, categories, series)
                        }
                    },
                },
                bar: {
                    dataLabels: {
                        enabled: true,
                        style: {
                            textOutline: 0
                        },
                    }
                }
            }
        });
    }
    handleClickChart = (e, categories, series) => {
        if (!this.props.callbackChangelevel) return
        var range_name = 2
        switch (e.point.colorIndex) {
            case 0:
                range_name = "% Top 2 Box"
                break;
            case 1:
                range_name = "% Rating 7-8"
                break;
            case 2:
                range_name = "% Bottom 0-6"
                break;
        }
        var quarter_number = 2
        switch (e.point.category) {
            case "Quarter 2/FY21":
                quarter_number = 2
                break;
            case "Quarter 3/FY21":
                quarter_number = 3
                break;
            case "Quarter 4/FY21":
                quarter_number = 4
                break;
            case "Quarter 1/FY21":
                quarter_number = 1
                break;

        }
        console.log(e.point.colorIndex)
        this.props.callbackChangelevel({
            level: 2,
            quarter_name: e.point.category,
            quarter_number: quarter_number,
            range_name: range_name,
            range_point: e.point.colorIndex
        })
    }
    render() {
        return (
            <div className={"chart-box"}>
                <center>
                    <div id="chart_3_1" style={{ width: "92%", height: "350px" }}></div>
                </center>
            </div>
        );
    }
}

export default Chart1;